import React from "react";
export default ({ onClick, active, label }) =>
  <button onClick={onClick}>
    <span>
      <svg height="10" width="6">
        <path transform="translate(1,1)" d="M0,0L4,4L0,8" />
      </svg>
      {label}
    </span>
    <style jsx>{`
      button {
        border: none;
        background: transparent;
        margin: 0;
        padding: 0;
        display: flex;
        cursor: pointer;
        min-width: 160px;
      }
      button.active {
        background: #585148;
        color: #fff;
      }
      button:focus {
        outline: none;
      }
      span {
        color: #007099;
        font-family: FrutigerLTCom;
        font-weight: 500;
        font-size: 14px;
        display: block;
        padding: 0 18px;
        line-height: 38px;
        box-sizing: border-box;
        height: 38px;
        flex-grow: 1;
        position: relative;
        text-indent: -12px;
      }
      svg {
        display: inline-block;
        margin-right: 6px;
      }
      path {
        fill: none;
        stroke: #007099;
        stroke-width: 2;
      }
    `}</style>
  </button>;



// WEBPACK FOOTER //
// ./src/components/Quiz/ButtonSecondary.js